import React from 'react';
import Icon, { Icons } from '../../../components/Icon/Icon';
import { almost_black } from '../../../styles/_variables';

import styles from './Homepage.module.scss';
import useHeader from '../../../hooks/useHeader';

type CardProps = {
  title: string;
  icon: Icons;
  description: string;
}

const Card = ({title, icon, description}: CardProps) => (
  <div className={styles.card}>
    <Icon icon={icon} color={almost_black}/>
    <span>{title}</span>
    <span>{description}</span>
  </div>
)

const Homepage = () => {
  // const setHeader = useHeader(state => state.setHeaderTitle)
  useHeader({ header: 'Página Inicial' });
  
  // setHeader('Página Inicial')

  return (
    <section className={styles.container}>
      <section className={styles.firstSection}>
        <div className={styles.image}>
          <img width={500} src='./assets/MF-p fundo claro@2x.png' alt="logo com fundo vermelho"></img>
        </div>
        <div>
          <p>Bem-vindo (a) ao Clubes de Leitura!</p>
          <p>Somos um gerenciador de Clubes de Leitura – aquele grupo
organizado de pessoas amantes de literatura e apaixonados em
compartilhar experiências de leitura.</p>
          <p>Quem nunca teve uma vontade colossal de comentar com alguém
sobre o livro que está lendo? Se esse é você, então o App combina
com você!</p>
          <p>Quer saber mais. <a href="/register">Inscreva-se.</a></p>
        </div>
      </section>
      <section className={styles.secondSection}>
        <div>
          <p>Quer manter a organização de suas leituras em dia? O lugar certo é
por aqui!</p>
          <p>Ou encontrar um clube de leitura que é a sua cara?</p>
          <p>Entre e “folheie” as páginas do App!</p>
          <p></p>
          <p>Quer saber mais. <a href="/register">Inscreva-se.</a></p>
        </div>
        <div>
          <div className={styles.image}>
              <img
                alt="Man Reading Book Vectors by Vecteezy" 
                src="./assets/Man_reading_book_character_illustration_generated-removebg-preview.png"/>
          </div>
        </div>
      </section>
      <section className={styles.thirdSection}>
        <span>Quem nunca leu um livro e deu aquela vontade explosiva de comentar com alguém sobre o que está lendo?</span>
      </section>
      <section className={styles.fourthSection}>
        <p>Funcionalidades para Clubes de Leitura, Leitores e Clubistas</p>
        <div className={styles.cards}>
          <Card title="Estante de livros" icon="bookcase" description="Organize seus livros"/>
          <Card title="Agenda do Clube" icon="calendar" description="Organize seu calendário de encontros e votações"/>
          <Card title="Curadoria" icon="group" description="Gerencie os membros do clube"/>
          <Card title="Vote" icon="votes" description="Decida os livros e as datas dos encontros"/>
          <Card title="Politica de Ingressos" icon="group" description="Controle quem entra no clube"/>
        </div>
        <p><strong>Junte-se.</strong></p>
      </section>
      <section className={styles.fifthSection}>
        <p>Um pouco mais do que oferecemos.</p>
        <div className={styles.cards}>
          <Card title="Livros mais lidos" icon="bookcase" description="Visualize os livros mais lidos pelos clubistas."/>
          <Card title="Clubes de Leitura do Brasil" icon="group" description="Visualize os clubes de leitura que combina mais
com você"/>
          <Card title="Visualize por Genêros literários" icon="bookcase" description="Tá procurando um genêro especifico?"/>
        </div>
        <p>Ainda tem dúvidas? Entre em contato conosco.</p>
      </section>
      <footer>
        <h1>Universidade Federal do Maranhão</h1>
        <div>
          <div className={styles.image}>
            <img
              width={5*18}
              height={5*18}
              alt="logo ufma" 
              src="./logo-ufma.png"/>
          </div>
        </div>
      </footer>
    </section>
  )
}

export default Homepage;